import styled from 'styled-components'

import StatisticGroup from '@/common/components/StatisticGroup/StatisticGroup'

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp24};
  align-items: center;

  @media (max-width: 1120px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const Summary = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp4};
`

export const ProgressBarContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`

export const Stats = styled(StatisticGroup)`
  flex: 1;
  min-width: 0;
`
